webpackJsonp([1],{

/***/ 823:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(829),
  /* template */
  __webpack_require__(852),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 829:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

__webpack_require__(842);

var _com = __webpack_require__(10);

var _vuex = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loginNameStr: '用户名',
            loginPasswdStr: '密码',
            form: {
                name: '',
                password: ''
            },
            rules: {
                name: [{ required: true, message: '请输入数据', trigger: 'blur' }, { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }],
                password: [{ required: true, message: '请输入数据', trigger: 'blur' }, { min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur' }]
            }
        };
    },
    created: function created() {
        console.info("getAppVer:%o", this.getAppVer);
        var appid = this.$store.state.route.query.appid || '';
        var token = this.$store.state.route.query.token || '';

        if (appid && token) {
            this.form.name = appid;
            this.form.password = token;
            this.$store.dispatch('TokenLogin', this);
        }
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
        getAppVer: 'getAppVer'
    }), {
        loginType: function loginType() {
            var type = this.$store.state.route.query.type || 'default';

            if (type === 'press') {
                this.loginNameStr = 'App ID';
                this.loginPasswdStr = 'App Secret';
            } else {
                this.loginNameStr = '用户名';
                this.loginPasswdStr = '密码';
            }

            return type;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        TokenLogin: 'TokenLogin'
    }), {
        onLogin: function onLogin(formName) {
            var _this = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    if (_this.loginType === 'press') {
                        _this.$store.dispatch('AppIdLogin', _this);
                    } else {
                        _this.$store.dispatch('onLogin', _this);
                    }
                } else {
                    if (_this.loginType === 'press') {
                        _this.$alert('密码错误', '系统通知', { confirmButtonText: '确定' });
                    } else {
                        _this.$alert('用户名 或 密码不能为空', '系统通知', { confirmButtonText: '确定' });
                    }
                }
            });
        },
        jumpLoginUrl: function jumpLoginUrl(type) {
            this.$router.push({ path: (0, _com.routeMap)('/login'), query: { type: type } });
        }
    })
};

/***/ }),

/***/ 835:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(820)();
// imports


// module
exports.push([module.i, ".border-bottom{border-bottom:1px solid #d1dbe5}.border-right{border-right:1px solid #d1dbe5}#login{height:100%}#login .login-header{padding:22px 0;height:60px}#login .login-header .header-logo{width:1200px;margin:0 auto;overflow:hidden}#login .login-header .header-logo h1{display:block;float:left;zoom:1;width:206px;height:60px;vertical-align:middle}#login .login-header .header-logo .header-link{display:inline-block;float:right;height:60px;line-height:60px;zoom:1;vertical-align:middle}#login .login-header .header-logo .header-link span{margin:0 10px}#login .login-bg{min-height:100%;min-width:1024px;width:100%;height:auto;position:fixed;top:0;left:0}#login .login-content{width:100%;height:100%}#login .login-content .content-wrap{width:100%;height:100%;margin:0 auto}#login .login-content .content-wrap .content-title{width:100%;z-index:1;position:relative}#login .login-content .content-wrap .content-title .title-wrap{position:absolute;width:360px;top:187.5px;left:0;line-height:0}#login .content-form{position:absolute;width:100%;height:100%}#login .content-form .form-wrap{height:100%;background-color:hsla(0,0%,100%,.8);padding-bottom:100px}#login .content-form .form-wrap h2{font-weight:400;font-size:1.2em}#login .content-form .form-wrap h1{font-weight:400;font-size:2.3em}#login .content-form .form-wrap .form-logo{margin-top:15%;margin-left:40%;width:100px}#login .content-form .form-wrap .form-content{width:60%;margin:5% auto}#login .content-form .form-wrap .form-content .content-login{margin-left:30%;width:40%}#login .content-form .form-wrap .form-jump{display:flex;flex-direction:row;justify-content:space-around;width:400px;margin:25% auto}#login .login-footer{width:1200px;margin:0 auto;text-align:center;margin-top:100px}#login .login-footer p{color:#aaa;line-height:1.7em}", "", {"version":3,"sources":["D:/project/beltline-git-clone/src/static/style/logins/D:\\project\\beltline-git-clone/src\\static\\style\\base\\min.scss","D:/project/beltline-git-clone/src/static/style/logins/D:\\project\\beltline-git-clone/src\\static\\style\\logins\\login.scss"],"names":[],"mappings":"AAmCA,eACI,+BApBiB,CAqBpB,AACD,cACI,8BAvBiB,CAwBpB,ACtCD,OACI,WAAY,CAyHf,AA1HD,qBAGQ,eAAe,AACf,WAAY,CAyBf,AA7BL,kCAMY,aDyBO,ACxBP,cAAc,AACd,eAAgB,CAoBnB,AA5BT,qCAUgB,cAAc,AACd,WAAW,AACX,OAAO,AACP,YAAY,AACZ,YAAY,AACZ,qBAAsB,CACzB,AAhBb,+CAkBgB,qBAAqB,AACrB,YAAY,AACZ,YAAY,AACZ,iBAAiB,AACjB,OAAO,AACP,qBAAsB,CAIzB,AA3Bb,oDAyBoB,aAAc,CACjB,AA1BjB,iBA+BQ,gBAAgB,AAChB,iBAAiB,AACjB,WAAW,AACX,YAAY,AACZ,eAAe,AACf,MAAM,AACN,MAAO,CACV,AAtCL,sBAwCQ,WAAW,AACX,WAAY,CAwBf,AAjEL,oCAiDY,WAAW,AACX,YAAY,AACZ,aAAc,CAajB,AAhET,mDAqDgB,WAAW,AACX,UAAU,AACV,iBAAkB,CAQrB,AA/Db,+DAyDoB,kBAAkB,AAClB,YAAY,AACZ,YAAY,AACZ,OAAO,AACP,aAAc,CACjB,AA9DjB,qBAsEQ,kBAAiB,AACjB,WAAW,AACX,WAAY,CAuCf,AA/GL,gCA8EY,YAAY,AACZ,oCAA0C,AAC1C,oBAAqB,CA8BxB,AA9GT,mCAkFgB,gBAAgB,AAChB,eAAgB,CACnB,AApFb,mCAsFgB,gBAAgB,AAChB,eAAgB,CACnB,AAxFb,2CA0FgB,eAAe,AACf,gBAAgB,AAChB,WAAY,CACf,AA7Fb,8CA+FgB,UAAU,AAEV,cAAe,CAKlB,AAtGb,6DAmGoB,gBAAgB,AAChB,SAAU,CACb,AArGjB,2CAwGgB,aAAa,AACb,mBAAmB,AACnB,6BAA6B,AAC7B,YAAY,AACZ,eAAgB,CACnB,AA7Gb,qBAiHQ,aDlFW,ACmFX,cAAc,AACd,kBAAkB,AAClB,gBAAiB,CAKpB,AAzHL,uBAsHY,WAAW,AACX,iBAAkB,CACrB","file":"login.scss","sourcesContent":["// 基础font-size\r\n$font: 62.5%;\r\n// 主色\r\n$bgPicton: #f9696c;\r\n\r\n$clWhite: #fff;\r\n$bgWhite: #fff;\r\n$clSupernova: #FBB83C;\r\n$bgSupernova: #FBB83C;\r\n$clJunebud: #B9D963;\r\n$bgJunebud: #B9D963;\r\n$bgPicton: #4EAFFC;\r\n$clDove: #747474;\r\n\r\n$clColor: #56667d;\r\n\r\n$borderColor: #d1dbe5;\r\n\r\n\r\n$fMoney: #FBB83C;\r\n\r\n// element 主色\r\n$lightBlue: #58B7FF;\r\n$blue: #20A0FF;\r\n$darkBlue: #1D8CE0;\r\n\r\n//element 辅助色\r\n$fBlue: #20A0FF;\r\n$fSuccess: #13CE66;\r\n$fWarning: #F7BA2A;\r\n$fDanger: #FF4949;\r\n\r\n// 登录页主内容宽度\r\n$loginWidth: 1200px;\r\n\r\n.border-bottom {\r\n    border-bottom: 1px solid $borderColor;\r\n}\r\n.border-right {\r\n    border-right: 1px solid $borderColor;\r\n}\r\n","@import \"../base/min\";\r\n\r\n#login {\r\n    height: 100%;\r\n    .login-header {\r\n        padding: 22px 0;\r\n        height: 60px;\r\n        .header-logo {\r\n            width: $loginWidth;\r\n            margin: 0 auto;\r\n            overflow: hidden;\r\n            h1 {\r\n                display: block;\r\n                float: left;\r\n                zoom: 1;\r\n                width: 206px;\r\n                height: 60px;\r\n                vertical-align: middle;\r\n            }\r\n            .header-link {\r\n                display: inline-block;\r\n                float: right;\r\n                height: 60px;\r\n                line-height: 60px;\r\n                zoom: 1;\r\n                vertical-align: middle;\r\n                span {\r\n                    margin: 0 10px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .login-bg{\r\n        min-height: 100%;\r\n        min-width: 1024px;\r\n        width: 100%;\r\n        height: auto;\r\n        position: fixed;\r\n        top: 0;\r\n        left: 0;\r\n    }\r\n    .login-content {\r\n        width: 100%;\r\n        height: 100%; // 600px;\r\n        // background-image: url(../../img/login-bg.jpg);\r\n        //background-image: url(../../img/tianjing.jpg);\r\n        //background-repeat: no-repeat;\r\n        //background-position: center center;\r\n        //background-size:100% 100%; //: cover;\r\n\r\n        .content-wrap {\r\n            width: 100%;\r\n            height: 100%;\r\n            margin: 0 auto;\r\n            .content-title {\r\n                width: 100%;\r\n                z-index: 1;\r\n                position: relative;\r\n                .title-wrap {\r\n                    position: absolute;\r\n                    width: 360px;\r\n                    top: 187.5px;\r\n                    left: 0;\r\n                    line-height: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .content-form {\r\n        /*width: 100%;\r\n        z-index: 1;*/\r\n        /*position: relative;*/\r\n        position:absolute;\r\n        width: 100%;\r\n        height: 100%;\r\n        .form-wrap {\r\n            /*position: fixed;\r\n            top: 0;\r\n            right: 0;\r\n            width: 50%;*/\r\n            height: 100%;\r\n            background-color: rgba(255, 255, 255, 0.8);\r\n            padding-bottom: 100px;\r\n            h2 {\r\n                font-weight: 400;\r\n                font-size: 1.2em;\r\n            }\r\n            h1 {\r\n                font-weight: 400;\r\n                font-size: 2.3em;\r\n            }\r\n            .form-logo{\r\n                margin-top: 15%;\r\n                margin-left: 40%;\r\n                width: 100px;\r\n            }\r\n            .form-content{\r\n                width: 60%;\r\n                //border:1px solid green;\r\n                margin: 5% auto;\r\n                .content-login {\r\n                    margin-left: 30%;\r\n                    width: 40%;\r\n                }\r\n            }\r\n            .form-jump{\r\n                display: flex;\r\n                flex-direction: row;\r\n                justify-content: space-around;\r\n                width: 400px;\r\n                margin: 25% auto;\r\n            }\r\n        }\r\n    }\r\n    .login-footer {\r\n        width: $loginWidth;\r\n        margin: 0 auto;\r\n        text-align: center;\r\n        margin-top: 100px;\r\n        p {\r\n            color: #aaa;\r\n            line-height: 1.7em;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(835);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(821)("1e721972", content, true);

/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bg_editor.d762987.jpg";

/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bg_guest.c180189.jpg";

/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [(_vm.loginType === 'press') ? _c('img', {
    staticClass: "login-bg",
    attrs: {
      "src": __webpack_require__(849)
    }
  }) : _c('img', {
    staticClass: "login-bg",
    attrs: {
      "src": __webpack_require__(848)
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "content-form",
    attrs: {
      "type": "flex",
      "justify": "end",
      "align": "middle"
    }
  }, [_c('el-col', {
    staticClass: "form-wrap",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 10,
      "lg": 10
    }
  }, [_c('img', {
    staticClass: "form-logo",
    attrs: {
      "src": __webpack_require__(283)
    }
  }), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v(_vm._s(_vm.getAppVer))]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "form-content",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "mt-20",
    attrs: {
      "placeholder": _vm.loginNameStr,
      "size": "large"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    staticClass: "mt-20",
    attrs: {
      "type": "password",
      "placeholder": _vm.loginPasswdStr,
      "size": "large"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "content-login",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onLogin('form')
      }
    }
  }, [_vm._v("登录")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.54b1c1887f728e47254b.js